function pad(value) {
  return String(value).padStart(2, "0");
}

export function formatLocalDate(date = new Date()) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseLocalDate(value) {
  if (!value) return null;
  const [year, month, day] = String(value).split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0, 0);
}

export function addLocalDays(value, days) {
  const date = typeof value === "string" ? parseLocalDate(value) : new Date(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  date.setDate(date.getDate() + days);
  return formatLocalDate(date);
}

export function getMonthToDateRange() {
  const today = new Date();
  return {
    from_date: formatLocalDate(new Date(today.getFullYear(), today.getMonth(), 1)),
    to_date: formatLocalDate(today),
  };
}

export function getPresetRange(preset) {
  const today = formatLocalDate(new Date());
  if (preset === "today") return { from_date: today, to_date: today };
  if (preset === "last_7_days") return { from_date: addLocalDays(today, -6), to_date: today };
  if (preset === "last_30_days") return { from_date: addLocalDays(today, -29), to_date: today };
  return getMonthToDateRange();
}
